export default __webpack_public_path__ + "static/media/40.4b794400.jpeg";